import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = [["new", "Нова"], ["confirmed", "Потвърдена"], ["shipped", "Изпратена"], ["delivered", "Доставена"], ["cancelled", "Отказана"]];
const statusColor = { new: "bg-gold text-white", confirmed: "bg-navy text-white", shipped: "bg-blue-600 text-white", delivered: "bg-green-600 text-white", cancelled: "bg-red-500 text-white" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/orders").then(({ data }) => setOrders(data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}`, { status });
    toast.success("Статусът е обновен");
    load();
  };

  return (
    <div data-testid="admin-orders">
      <h1 className="font-serif text-3xl text-navy mb-6">Поръчки <span className="text-base text-charcoal/40">({orders.length})</span></h1>
      {orders.length === 0 ? <p className="text-charcoal/50">Все още няма поръчки.</p> : (
        <div className="bg-white border border-stone overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-stone text-navy"><tr>
              <th className="text-left p-3">№</th><th className="text-left p-3">Клиент</th><th className="text-left p-3 hidden md:table-cell">Телефон</th><th className="text-left p-3">Сума</th><th className="text-left p-3">Статус</th><th className="p-3"></th>
            </tr></thead>
            <tbody>
              {orders.map((o) => (
                <React.Fragment key={o.id}>
                  <tr className="border-t border-stone" data-testid={`order-row-${o.id}`}>
                    <td className="p-3 text-navy font-medium">{o.order_number}</td>
                    <td className="p-3">{o.name}</td>
                    <td className="p-3 hidden md:table-cell text-charcoal/60">{o.phone}</td>
                    <td className="p-3 text-navy">{formatPrice(o.total)}</td>
                    <td className="p-3">
                      <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className={`text-xs px-2 py-1 ${statusColor[o.status] || "bg-stone"}`} data-testid={`order-status-${o.id}`}>
                        {STATUSES.map(([v, l]) => <option key={v} value={v} className="bg-white text-navy">{l}</option>)}
                      </select>
                    </td>
                    <td className="p-3 text-right"><button onClick={() => setOpen(open === o.id ? null : o.id)} className="text-gold text-xs underline">{open === o.id ? "Скрий" : "Детайли"}</button></td>
                  </tr>
                  {open === o.id && (
                    <tr className="bg-ivory"><td colSpan={6} className="p-4">
                      <div className="grid sm:grid-cols-2 gap-4 text-sm">
                        <div><p className="text-charcoal/50">Доставка</p>
                          {o.delivery_method === "office"
                            ? <p className="text-navy">Офис на куриер ({o.courier === "speedy" ? "Спиди" : "Еконт"}): {o.office}, {o.city}</p>
                            : <p className="text-navy">До адрес: {o.address}, {o.city} {o.post_code}</p>}
                          {o.note && <p className="text-charcoal/60 mt-1">Бележка: {o.note}</p>}<p className="text-charcoal/60 mt-1">Плащане: {o.payment_method === "cod" ? "Наложен платеж" : "Карта"}</p></div>
                        <div><p className="text-charcoal/50 mb-1">Артикули</p>{o.items?.map((it, i) => <p key={i} className="text-navy">{it.qty} × {it.title} — {formatPrice(it.price)}</p>)}</div>
                      </div>
                    </td></tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
